/* global clearInterval, console, setInterval */


/**
 * check version
 * @customfunction
 * @returns {string} check version of add-in.
 * @helpurl https://www.brbrsoft.com/
 */
export function a_version_eeFunction() {
  // return "publish on 2023-03-05";
  return "publish on 2026-01-02";
}


/**
 * Add two numbers
 * @customfunction
 * @param {number} first First number
 * @param {number} second Second number
 * @returns {number} The sum of the two numbers.
 */
export function add(first, second) {
  return first + second;
}


/**
 * Writes a message to console.log().
 * @customfunction LOG
 * @param {string} message String to write.
 * @returns String to write.
 */
export function logMessage(message) {
  console.log(message);

  return message;
}



// Helper function to ensure CoolProp is ready
function waitForCoolProp() {
  return new Promise((resolve) => {
    // Check for Module in both global and self scopes
    const checkModule = () => {
      if (typeof Module !== 'undefined' && Module.HAPropsSI && Module.PropsSI) {
        return true;
      }
      if (typeof self !== 'undefined' && typeof self.Module !== 'undefined' && 
          self.Module.HAPropsSI && self.Module.PropsSI) {
        return true;
      }
      return false;
    };

    if (checkModule()) {
      resolve();
      return;
    }
    
    if (typeof self !== 'undefined' && self.coolPropReady) {
      resolve();
      return;
    }
    
    if (typeof self !== 'undefined') {
      self.coolPropReadyCallbacks = self.coolPropReadyCallbacks || [];
      self.coolPropReadyCallbacks.push(resolve);
    }
    
    // Fallback: poll for Module availability with longer timeout
    let attempts = 0;
    const maxAttempts = 100; // 10 seconds (100 * 100ms)
    const checkInterval = setInterval(() => {
      attempts++;
      if (checkModule()) {
        clearInterval(checkInterval);
        resolve();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        console.error('Module failed to load after 10 seconds');
        resolve(); // Resolve anyway to allow error handling in the calling function
      }
    }, 100);
  });
}


/**
 * Check Module status for debugging
 * @customfunction
 * @returns {string} Module status
 */
export function COOLPROP_STATUS() {
  try {
    const status = [];
    
    // Check Module in global scope
    status.push("Global Module: " + (typeof Module !== 'undefined' ? 'defined' : 'undefined'));
    if (typeof Module !== 'undefined') {
      status.push("HAPropsSI: " + (typeof Module.HAPropsSI === 'function' ? 'OK' : 'missing'));
      status.push("PropsSI: " + (typeof Module.PropsSI === 'function' ? 'OK' : 'missing'));
    }
    
    // Check self.Module
    if (typeof self !== 'undefined') {
      status.push("self.Module: " + (typeof self.Module !== 'undefined' ? 'defined' : 'undefined'));
      if (typeof self.Module !== 'undefined') {
        status.push("self.Module.HAPropsSI: " + (typeof self.Module.HAPropsSI === 'function' ? 'OK' : 'missing'));
      }
      status.push("coolPropReady: " + (self.coolPropReady ? 'true' : 'false'));
    } else {
      status.push("self: undefined");
    }
    
    return status.join(", ");
  } catch (error) {
    return "ERROR: " + error.message;
  }
}


/**
 * CoolProp PropsSI function as input {OutputName, InputName1, Input1, InputName2, Input2, Fluid}
 * @customfunction
 * @param {string} OutputName output parameter,
 * @param {string} InputName1 input1 parameter,
 * @param {number} InputValue1 number1,
 * @param {string} InputName2 input2 parameter,
 * @param {number} InputValue2 number2,
 * @param {string} Fluid fluid name,
 * @returns {number} get number,
 * @helpurl http://coolprop.org/coolprop/HighLevelAPI.html#table-of-string-inputs-to-propssi-function
 */
export async function PropsSI(OutputName, InputName1, InputValue1, InputName2, InputValue2, Fluid) {
  try {
    await waitForCoolProp();
    
    // Try to get Module from both scopes
    const Mod = typeof Module !== 'undefined' ? Module : 
                (typeof self !== 'undefined' && typeof self.Module !== 'undefined' ? self.Module : null);
    
    if (!Mod || typeof Mod.PropsSI !== 'function') {
      throw new Error('This module is not supported in Desktop Excel.');
    }

    return Mod.PropsSI(OutputName, InputName1, InputValue1, InputName2, InputValue2, Fluid);
  } catch (error) {
    console.error('PropsSI error:', error);
    return `#ERROR: ${error.message}`;
  }
}
CustomFunctions.associate("A_VERSION_EEFUNCTION", a_version_eeFunction);
CustomFunctions.associate("ADD", add);
CustomFunctions.associate("LOG", logMessage);
CustomFunctions.associate("COOLPROP_STATUS", COOLPROP_STATUS);
CustomFunctions.associate("PROPSSI", PropsSI);